import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import { Nav, NavItem, NavMenu } from '@feathr/components';
import { useLocalUrl, useRole } from '@feathr/extender/state';

import HomeMarketingNav from './HomeMarketingNav';

interface IHomeNavProps {
  indented?: boolean;
}

function HomeNav({ indented = true }: Readonly<IHomeNavProps>): JSX.Element | null {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const { isSudoer, hasProjectsSome, hasSegmentsSome } = useRole();
  const match = useRouteMatch<{ accountId: string; primary: string }>({
    path: '/:accountId/:primary',
  });
  const isDashboardVisible = !hasProjectsSome && !hasSegmentsSome;

  if (!match) {
    return null;
  }

  return (
    <Nav indented={indented} label={'Home navigation'} type={'vertical'}>
      {isDashboardVisible && (
        <NavItem
          data-command={'true'}
          data-command-description={t('View your dashboard overview')}
          data-command-keywords={'dashboard,overview,home'}
          data-command-label={t('Dashboard')}
          to={localUrl('/dashboard')}
        >
          {t('Dashboard')}
        </NavItem>
      )}
      <NavMenu
        data-command={'true'}
        data-command-description={t('Marketing tools and campaigns')}
        data-command-keywords={'marketing,campaigns,tools'}
        data-command-label={t('Marketing')}
        hasDefaultChild={true}
        menu={<HomeMarketingNav />}
        to={localUrl('/marketing')}
      >
        {t('Marketing')}
      </NavMenu>
      {isSudoer && (
        <NavItem
          data-command={'true'}
          data-command-description={t('Manage accounts')}
          data-command-keywords={'accounts,manage,admin'}
          data-command-label={t('Accounts')}
          to={localUrl('/accounts')}
        >
          {t('Accounts')}
        </NavItem>
      )}
    </Nav>
  );
}

export default HomeNav;
